import { Box, Text } from '@cdl/heartbeat-react';

interface Props {
  color?: string;
  label: string;
  value: number;
  metricUnit: string;
}

export const MetricCard: React.FC<Props> = ({
  color,
  label,
  value,
  metricUnit,
}) => {
  return (
    <Box>
      <Text
        textStyle='category-subtitle'
        fontWeight='semibold'
        color='neutral.400'
        mb='xs'
      >
        {label}
      </Text>
      <Text textStyle='category-subtitle' fontWeight='semibold' color={color}>
        {`${value} ${metricUnit}`}
      </Text>
    </Box>
  );
};
